import * as React from "react";
import styles from "./styles.module.css";
import { Author } from "@/types/article";

const ArticleAuthor: React.FC<{
	author: Author | undefined;
	lastUpdated: string;
}> = ({ author, lastUpdated }) => {
	return (
		<div className="d-flex align-items-center">
			<div className={styles.author__circle}>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="32"
					height="32"
					fill="currentColor"
					className="bi bi-person-fill"
					viewBox="0 0 16 16"
				>
					<path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
				</svg>
			</div>
			<div className={`${styles.author__content}`}>
				<h5>By {author?.fields.name}</h5>
				<p>Last updated on {lastUpdated}</p>
			</div>
		</div>
	);
};

export default ArticleAuthor;
